var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "red-x-line-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.961,
    height: 48.961,
    viewBox: "0 0 48.961 48.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_103153",
    "data-name": "Path 103153",
    d: "M24.481,0A24.468,24.468,0,1,1,7.166,7.166,24.442,24.442,0,0,1,24.481,0Zm4.786,15.6a2.794,2.794,0,0,1,3.979-.01,2.862,2.862,0,0,1,.011,4.018l-4.807,4.875,4.812,4.881a2.837,2.837,0,0,1-.032,3.993,2.791,2.791,0,0,1-3.966,0l-4.78-4.846-4.788,4.856a2.792,2.792,0,0,1-3.978.01,2.861,2.861,0,0,1-.01-4.017l4.806-4.876L15.7,19.6a2.838,2.838,0,0,1,.033-3.993,2.791,2.791,0,0,1,3.966.005l4.78,4.847L29.267,15.6Zm9.342-5.248A19.985,19.985,0,1,0,44.46,24.481a19.917,19.917,0,0,0-5.851-14.129Z",
    fill: "#ff4141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectIcon);
export default __webpack_public_path__ + "static/media/incorrect-icon.2404604c2c5e0ed925553f047beff7c3.svg";
export { ForwardRef as ReactComponent };